<template>
  <div class="account-setting">
    <!-- <Navbar title="设置"></Navbar> -->
    <div class="List">
      <div class="Lists" v-for="(item, index) in List" :key="index">
        <div class="commodity">
          <span>{{ item.spec1 != "" ? item.spec1 : "null" }}</span>
          <span>{{ item.goodsSpec != "" ? item.goodsSpec : "null" }}</span>
          <span>{{ "x" + item.count }}</span>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="bottom_Sub">
      <div class="bottom_Sub_div">
        <van-field
          readonly
          clickable
          name="picker"
          :value="value"
          label="出库对象"
          placeholder="请选择出库对象"
          @click="showClick"
        />
        <div class="money">
          <van-icon
            :name="require('@/assets/delivery/money.png')"
            class="money_icon"
          />
          <van-field
            class="money_input"
            v-model="amount"
            clearable
            placeholder="请填写出货价格"
          />
          <span>元</span>
        </div>
      </div>
      <van-button
        type="primary"
        size="large"
        round
        color="#1c86dc"
        style="
          width: 60%;
          font-size: 1rem;
          margin-top: 2rem;
          color: white;
          background: rgb(28, 134, 220);
          border-color: rgb(28, 134, 220);
        "
        @click="onSubmit"
        >提交</van-button
      >
    </div>
    <van-popup
      v-model="showPicker"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { goodsSpecCount, child, outStock } from "@/api/exwarehouse";
import { Dialog } from "vant";

export default {
  data() {
    return {
      logistics: this.$route.params.logistics,
      showPicker: false,
      value: "",
      columns: [],
      amount: "",
      List: [],
      id: "",
    };
  },
  mounted() {
    console.log(this.logistics);
    this.goodsSpecCounts(this.logistics);
  },
  methods: {
    goodsSpecCounts(data) {
      goodsSpecCount(data)
        .then((res) => {
          this.List = res.result;
          console.log("预览: ", res.result);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onConfirm(value) {
      this.value = value.name;
      this.id = value.id;
      this.showPicker = false;
    },
    showClick() {
      this.columns = [];
      child()
        .then((res) => {
          res.result.map((items) => {
            if (!items.directProxy) {
              this.columns.push({
                name: items.fullName,
                id: items.id,
              });
            }
          });
          this.showPicker = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit() {
      if (this.id.length != 0) {
        const datas = {
          amount: this.amount * 100,
          items: this.logistics,
          outStockMerchantId: this.id,
        };
        outStock(datas)
          .then((res) => {
            if (res.code == 0) {
              localStorage.removeItem("codes");
              Dialog.alert({
                title: "出库成功",
                message: "回到首页查看明细",
              }).then(() => {
                // on close
                this.$router.push({
                  name: "SweeCode",
                });
                this.List = [];
                this.logistics = [];
              });
            } else {
              this.$toast("提交出库失败!");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }else{
        this.$toast("请选择出库对象!");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.account-setting {
  height: 100vh;
  background: #ebebeb;
  overflow-y: hidden;
  .List {
    background: #ffffff;
    height: 65%;
    overflow-y: scroll;
    .Lists {
      width: 80%;
      margin: 0 auto;
      height: 50px;
      text-align: left;
      line-height: 50px;
      border-bottom: 1px solid #d8d8d8;
      .commodity {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .divider {
    width: 100%;
    height: 10px;
    background: #ebebeb;
  }
  .bottom_Sub {
    width: 100%;
    background: #fff;
    height: 35%;
    .bottom_Sub_div {
      width: 80%;
      margin: 0 auto;
      padding: 0.4rem 0;
      border-bottom: 1px solid #eee;
      .money {
        display: flex;
        justify-content: space-around;
        align-items: center;
        .money_icon {
          font-size: 1.5rem;
        }
        .money_input {
          width: 77%;
        }
      }
    }
  }
}
</style>
